
interface StatusTagProps{
  status: string;
}

function StatusTag({...props}:StatusTagProps) {
  let statusClass = "";

  switch(props.status.toLowerCase()){
    case "pending":
      statusClass = "polymer-status-tag-pending";
      break;
    case "completed":
      statusClass = "polymer-status-tag-completed";
      break;
    case "overdue":
      statusClass = "polymer-status-tag-overdue";
      break;
  }

  return(
    <div className={`polymer-status-tag ${statusClass}`}>
      {props.status}
    </div>
  );
}

export default StatusTag;